<template>
	<div class="loginTan">
		<div class="zzc" v-if="loginTan" @click="loginTan = false"></div>
		<div class="login" v-if="loginTan">
			<div class="top">
				<img src="@/assets/images/login_icon.png" alt="">
				<h2>欢迎登录<span>赢在高考，为您选择更好的学校</span></h2>
			</div>
			<div class="tabs">
				<span :class="{ side: tabIndex == 0 }" @click="resetForm(0, 'form1')">密码登录</span>
				<span :class="{ side: tabIndex == 1 }" @click="resetForm(1, 'form2')">短信登录</span>
			</div>
			<div class="tabCon">
				<div class="form">
					<el-form ref="form1" :model="form1" :rules="rules1" v-show="tabIndex == 0" v-loading="loading">
						<el-form-item prop="account" class="form-item">
							<el-input v-model="form1.account" placeholder="请输入账户/手机/邮箱" class="form-item-input account">
							</el-input>
						</el-form-item>
						<el-form-item prop="password" class="form-item">
							<el-input v-model="form1.password" show-password placeholder="请输入登录密码" class="form-item-input password"
								@keyup.enter.native="onSubmit('form1')">
							</el-input>
							<router-link class="code-btn" to="/personal/retrieve-password">忘记密码</router-link>
						</el-form-item>
					</el-form>
					<el-form ref="form2" :model="form2" :rules="rules2" v-show="tabIndex == 1">
						<el-form-item prop="phone" class="form-item">
							<el-input v-model="form2.phone" maxlength="11" placeholder="请输入手机号" class="form-item-input phone">
							</el-input>
						</el-form-item>
						<el-form-item prop="code" class="form-item">
							<el-input v-model="form2.code" maxlength="6" placeholder="请输入短信验证码" class="form-item-input code"
								@keyup.enter.native="onSubmit('form2')">
							</el-input>
							<span class="code-btn" @click="getCode" :style="{ color: fontColor }">{{ codeText }}</span>
						</el-form-item>
					</el-form>
					<div class="form-item form-item0">
						<button class="onSubmit" @click="onSubmit('form1')" v-if="tabIndex == 0">
							登录
						</button>
						<button class="onSubmit" @click="onSubmit('form2')" v-if="tabIndex == 1">
							登录
						</button>
					</div>
					<div class="form-item">
						<div class="formRight">
							<router-link to="/personal/register">注册新用户</router-link>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import myCaptcha from "@/assets/js/myCaptcha";
export default {
	name: "loginTan",
	data() {
		return {
			loginTan: false,
			loading: false, //登录中
			// 登录方式
			tabIndex: 0,
			// 密码登录
			form1: {
				account: "",
				password: "",
			},
			rules1: {
				account: [{
					required: true,
					message: "请输入账户/手机/邮箱",
					trigger: "blur",
				},],
				password: [{
					required: true,
					message: "请输入密码",
					trigger: "change",
				},
				{
					min: 10,
					message: "密码最少10位数哦",
					trigger: "blur",
				},
				],
			},
			// 验证码登录
			form2: {
				phone: "",
				code: "",
			},
			rules2: {
				phone: [{
					required: true,
					message: "请输入手机号码",
					trigger: "change",
				},
				{
					trigger: "blur",
					validator: (rule, value, callback) => {
						var passwordreg =
							/^(((13[0-9]{1})|(15[0-9]{1})|(16[0-9]{1})|(17[3-8]{1})|(18[0-9]{1})|(19[0-9]{1})|(14[5-7]{1}))+\d{8})$/;
						if (!passwordreg.test(value)) {
							callback(new Error("请输入正确的手机号码哦!"));
						} else {
							callback();
						}
					},
				},
				],
				code: [{
					required: true,
					message: "请输入短信验证吗",
					trigger: "blur",
				},],
			},

			codeText: "获取验证码", // 验证码字符
			disabled: false, //验证码是否禁用
			fontColor: "",
		};
	},
	watch: {
		$route(to, from) {
			this.loginTan = false;
		},
	},
	mounted() { },
	methods: {
		open() {
			this.loginTan = true;
		},
		close() {
			this.loginTan = false;
		},
		resetForm(e, formName) {
			this.tabIndex = e;
			this.$refs[formName].resetFields();
		},
		onSubmit(formName) {
			this.$refs[formName].validate((valid) => {
				if (valid) {
					this.login();
				} else {
					console.log("error submit!!");
					return false;
				}
			});
		},
		login() {
			let urls, dataObj;
			if (this.tabIndex == 0) {
				urls = "Login/Account";
				dataObj = {
					paaSPort: 1,
					mobile: this.form1.account,
					password: this.form1.password,
				};
			} else if (this.tabIndex == 1) {
				urls = "Login/MobileCode";
				dataObj = {
					paaSPort: 1,
					mobile: this.form2.phone,
					mobileCode: this.form2.code,
				};
			}
			this.loading = true;
			this.$request({
				api: "plan",
				url: urls,
				method: "post",
				data: dataObj,
			})
				.then((res) => {
					console.log(res, "res");
					this.$message.success(res.message);
					res.data.userInfo.phone = res.data.userInfo.mobile.replace(
						/^(\d{3})\d{4}(\d{4})$/,
						"$1****$2"
					);
					let expiresNum = res.data.expiration;
					if (this.checked) {
						expiresNum = 30;
					}
					console.log(expiresNum, '过期时间++++****')
					this.cookie.set("token", res.data.access_token, {
						expires: expiresNum,
					});
					this.cookie.set("userInfo", JSON.stringify(res.data.userInfo), {
						expires: expiresNum,
					});
					//登录之后的一些公共操作
					this.$utils.operateAboutLogin(res.data);
					this.$store.state.userInfo = res.data.userInfo;
					this.$store.state.loginSuccess = true;
					this.loading = false;
					this.$store.state.city = res.data.userInfo.province;
					this.close();
				})
				.catch((err) => {
					this.$message.error(err.message);
					this.loading = false;
					return;
				});
		},
		codeLogic(res) {
			console.log("回调了", res);
			this.$request({
				api: "passport",
				url: "MobileCode/SendSmsCode",
				method: "post",
				data: {
					areaCode: "86",
					mobile: this.form2.phone,
					systemPaaS: 14,
					paaSPort: 1,
					codeType: 4,
					ticket: res.ticket,
					randstr: res.randstr,
					signName: "启德教育",//"赢在高考",
				},
			})
				.then((res) => {
					console.log(res);
					this.codeText = "发送成功";
					this.fontColor = "#35e100";
					let times = setTimeout(() => {
						// 60秒后重发
						var time = 60; //倒计时默认值
						this.codeText = "60秒后重发";
						this.disabled = true;
						this.fontColor = "#b2b2b2";
						// 执行倒计时
						var Interval = setInterval(() => {
							time--;
							if (time > 0) {
								this.codeText = time + "秒后重发";
							} else {
								clearInterval(Interval);
								this.codeText = "获取验证码";
								this.disabled = false;
								this.fontColor = "";
								clearTimeout(times);
							}
						}, 1000);
					}, 1000)
				})
				.catch((err) => {
					console.log(err, "err");
					this.$alert(err, '提示');
					return;
				});
		},
		// 点击获取验证码
		async getCode() {
			if (this.disabled) return;
			console.log(this.$request);
			this.$refs.form2.validateField("phone", async (valid) => {
				console.log(valid);
				if (!valid) {
					myCaptcha(this.codeLogic);
				} else {
					console.log("error submit!!");
					return false;
				}
			});
		},
	},
};
</script>

<style lang="scss" scoped>
.loginTan {
	.zzc {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100vh;
		z-index: 999;
		background-color: rgba($color: #000000, $alpha: 0.8);
	}

	.login {
		width: 446px;
		height: 460px;
		background: #FFFFFF;
		border-radius: 6px;
		margin: 0 auto;
		padding: 30px;
		position: absolute;
		top: 20%;
		left: 50%;
		margin-left: -223px;
		z-index: 999;

		.top {
			display: flex;
			align-items: center;
			margin-bottom: 50px;

			img {
				display: block;
				width: 80px;
				height: 80px;
				margin-right: 10px;
			}

			h2 {
				font-family: SourceHanSansCN, SourceHanSansCN;
				font-weight: 500;
				font-size: 30px;
				color: #333333;
				line-height: 30px;

				span {
					display: block;
					font-family: SourceHanSansCN, SourceHanSansCN;
					font-weight: 500;
					font-size: 16px;
					color: #003B4F;
					line-height: 16px;
					padding-top: 10px;
				}
			}
		}

		.tabs {
			display: flex;
			justify-content: space-between;
			height: 20px;
			margin-bottom: 24px;
			padding-right: 200px;

			span {
				display: block;
				font-family: SourceHanSansCN, SourceHanSansCN;
				font-weight: 400;
				font-size: 20px;
				color: #999999;
				line-height: 20px;
				text-align: left;
				font-style: normal;
				cursor: default;

				&.side {
					color: #333333;
				}
			}
		}

		.tabCon {

			.form-item {
				display: flex;
				justify-content: space-between;
				margin-bottom: 20px;
				position: relative;

				&.form-item0 {
					padding-top: 10px;
				}

				.form-item-input {
					width: 386px;
					height: 42px;
					background: #FFFFFF;
					border-radius: 3px;
					border: 1px solid #DCDCDC;
					padding: 0 20px;

					&.password {
						padding-right: 114px;
					}

					:deep(.el-input__inner) {
						border: none;
						width: 100%;
						height: 100%;
						padding: 0;
						background: none;
						font-size: 14px;
					}
				}

				.code-btn {
					width: 110px;
					position: absolute;
					right: 1px;
					top: 1px;
					line-height: 40px;
					font-size: 14px;
					font-family: Source Han Sans CN-Bold, Source Han Sans CN;
					color: #D70024;
					text-align: center;
					cursor: pointer;
					background: #fff;
					border-radius: 3px;
				}

				.onSubmit {
					width: 386px;
					height: 42px;
					background: #D70024;
					border-radius: 3px;
					margin: 0 auto;
					font-family: SourceHanSansCN, SourceHanSansCN;
					font-weight: 400;
					font-size: 16px;
					color: #FFFFFF;
					line-height: 42px;
					text-align: center;
					border: none;
				}

				.formRight {
					width: 100%;
					text-align: center;

					a {
						font-size: 14px;
						font-family: Source Han Sans CN-Regular, Source Han Sans CN;
						font-weight: 400;
						color: #D70024;
						line-height: 20px;
						text-decoration: underline;
					}
				}
			}
		}
	}
}
</style>
